/** A non-null object whose properties can be read by name (parsed JSON, error extensions). */
const isRecord = (value: unknown): value is Record<string, unknown> =>
  typeof value === 'object' && value !== null && !Array.isArray(value);

export default isRecord;
